var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"headerarea"},[_c('Header')],1),_c('div',[_c('Nav')],1),_c('div',{staticClass:"corearea"},[_c('router-view',{key:Math.random()})],1),_c('div',[_c('Footer')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }